import { rootApi } from "../../api/rootApi";

export const appLoginAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchLoginHistory: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/app/app-logins/`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    })
  }),
});

export const { useFetchLoginHistoryMutation} = appLoginAPI;
